module.exports = __webpack_public_path__ + "img/ch15_03_巷口报警.42157363.jpg";